import axios from "axios";
import React, { useState, createContext, useEffect, useRef } from "react";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import BackEndUrl from "../../backURL";
const backend = BackEndUrl.domain;
const backend_ = BackEndUrl.domain;
const modified_backend_Url = backend_.replace(/^https:\/\//, '');
const client = new W3CWebSocket('wss://'+modified_backend_Url);

export const StaffContext = createContext();
client.onopen = () => {};


export const StaffContextProvider = ({ children }) => {
  const reqIntervalRef = useRef(null);
  const [pendingRequests, setPendingRequests] = useState(null);
  const [rejectedRequests, setRejectedRequests] = useState(null);
  const [acceptedRequests, setAcceptedRequests] = useState(null);
  const[completedRequests,setCompletedRequests]= useState(null);


  const [pendingRequestsContactUs, setPendingRequestsContactUs] = useState(null);
  const [noOfPendingRequestsContactUs, setNoOfPendingRequestsContactUs] = useState(null);


  async function getPendingReq() {
    try {
      const response = await axios.get(`${backend}/pending-reqs`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      //console.log(response.data);
      setPendingRequests(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  async function getAcceptedReq() {
    try {
      const response = await axios.get(`${backend}/accepted-reqs`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      console.log(response.data)
      setAcceptedRequests(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  async function getRejectedReq() {
    try {
      const response = await axios.get(`${backend}/rejected-reqs`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      console.log(response.data)
      setRejectedRequests(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  async function getCompletedReq() {
    try {
      const response = await axios.get(`${backend}/completed-reqs`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      //console.log(response.data)
      setCompletedRequests(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function getPendingReqContactUs() {
    try {
      const response = await axios.get(`${backend}/pending-reqs-contactus`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      console.log(response.data);
      setPendingRequestsContactUs(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function getNoOfPendingReqContactUs() {
    try {
      const response = await axios.get(`${backend}/pending-reqs-contactus-no`, {
        headers: {
          Authorization: sessionStorage.getItem('staff-token'),
        }
      });
      //console.log(response.data);
      setNoOfPendingRequestsContactUs(response.data);
    } catch (error) {
      console.log(error);
    }
  }


  client.onmessage = (message) => {
    getPendingReq();
    getAcceptedReq();
    getRejectedReq();
    getCompletedReq();
    getPendingReqContactUs();
    getNoOfPendingReqContactUs();
  };

  useEffect(() => {
    // Initial fetch
    if (!pendingRequests) {
      getPendingReq();
    }if(!acceptedRequests){
      getAcceptedReq();
    }
    if(!rejectedRequests){
      getRejectedReq();
    }
    if(!completedRequests){
      getCompletedReq();
    }
    if (!pendingRequestsContactUs) {
      getPendingReqContactUs();
    }
    if(!noOfPendingRequestsContactUs){
      getNoOfPendingReqContactUs();
    }


    return () => {
      // Clear interval on component unmount
      clearInterval(reqIntervalRef.current);
    };
  }, [pendingRequests]);

  return (
    <StaffContext.Provider
      value={{
        acceptedRequests,
        pendingRequests,
        rejectedRequests,
        completedRequests,
        pendingRequestsContactUs,
        noOfPendingRequestsContactUs,
        setRejectedRequests,
        setPendingRequests,
        setAcceptedRequests,
        setCompletedRequests,
        setPendingRequestsContactUs,
        getPendingReq: () => {
          getPendingReq();
        },
        getAcceptedReq:()=>{
          getAcceptedReq()
        },
        getRejectedReq:()=>{
          getRejectedReq()
        },
        getCompletedReq:()=>{
          getCompletedReq()
        },
        getPendingReqContactUs: () => {
          getPendingReqContactUs()
        },
        getNoOfPendingReqContactUs : () =>{
          getNoOfPendingReqContactUs()
        }
      }}
    >
      {children}
    </StaffContext.Provider>
  );
};
